/* global angular, moment */

/**
 * Created by lari on 08/06/2017.
 */

/* either pass list of doctors (patients) to display or load doctors */


(function () {
  'use strict';
  angular.module('vcutils.doctor')
    .component('doctorlist', {
      restrict: 'E',
      bindings: {
        doctors: '<?'
      },
      template: `
        <div class="doctorlist-component" data-hook="doctorlist-component">
          <table class="table table-striped">
              <thead>
              <tr>
                  <th>Nachname/Institut</th>
                  <th>Vorname</th>
                  <th>Spezialisierung</th>
                  <th>Ort</th>
                  <th></th>
              </tr>
              </thead>
              <tr ng-repeat="doctor in vm.doctors">
                  <td>{{doctor.lastname}} {{doctor.institute}} </td>
                  <td>{{doctor.firstname}}</td>
                  <td>{{doctor.speciality}}</td>
                  <td>{{doctor.postcode}} {{doctor.city}}</td>
                  <td>
                      <button class="btn btn-primary" ng-click="vm.editDoctor(doctor)">Editeren</button>
                      <button class="btn btn-danger" ng-click="vm.removeDoctor(doctor)">Löschen</button>
                  </td>
              </tr>
          </table>
          
          <div uib-pagination total-items="vm.totalItems"
                          items-per-page="{{vm.pageSize}}"
                          max-size="10"
                          first-text="Erste"
                          last-text="Letzte"
                          next-text="N&auml;chste"
                          previous-text="Vorige"
                          boundary-links="true"
                          rotate="false"
                          ng-model="vm.currentPage"
                          ng-change="vm.pageChanged()"></div>
        </div>
      `,
      controllerAs: 'vm',
      controller: ['$log', '$http', 'Rlog', 'Doctor', 'DoctorHelper', 'vertxEventBusService',
        function ($log, $http, Rlog, Doctor, DoctorHelper, vertxEventBusService) {
          let vm = this;
          vm.pageSize = 10;
          vm.currentPage = 1;
          vm.pageChanged = pageChanged;
          vm.removeDoctor = removeDoctor;
          vm.editDoctor = DoctorHelper.editDoctor;
          
          
          vm.$onInit = function () {
            // unless doctor list has been passed for test purposes, retrieve doctor list from web
            if (angular.isUndefined(vm.doctors)) {
              // $log.debug('### doctors loading from backend');
              
              let search = {};
              search.page = vm.currentpage;
              search.query = {};
              search.query.active = true;
              search.options = {};
              
              if (angular.isDefined(vm.pageSize)) {
                search.options.pagesize = vm.pageSize;
              }
              
/*              search.options.fields = {
                _id: 1,
                created: 1,
                speciality: 1,
                institute: 1,
                lastname: 1,
                firstname: 1,
                titlefront: 1,
                titleback: 1,
                address: 1,
                postcode: 1,
                city: 1,
                phone1: 1,
                phone2: 1,
                fax: 1,
                email:1,
                notes: 1
              };*/
              let sort = {};
              sort['institute'] = 1;
              sort['lastname'] = 1;
              
              search.options.sort = sort;
              
              Doctor.$search(search).$then(function (doctors) {
                vm.doctors = doctors;
                vm.totalItems = doctors.$pageCount;
              });
            }
          }; // $onInit()
  
  
          function removeDoctor(doctor) {
            doctor.active = false;
            doctor.$save();
            pageChanged();
          }

          function pageChanged() {
            vm.doctors.$refresh({page: vm.currentPage}).$then(function (doctors) {
              vm.totalItems = doctors.$pageCount;
            });
          }
  

          const doctorsUpdateHandler = function (message) {
            $log.debug('debug: doctor update received: ', message);
            if (angular.isDefined(vm.doctors)){
              vm.doctors.$refresh({page: vm.currentPage}).$then(function (doctors) {
                vm.totalItems = doctors.$pageCount;
                $log.debug('debug: doctorlist refreshed doctors');
              }, function (err) {
                $log.debug('debug: doctorlist refresh doctors failed: ', err);
              });
            }
          };

          vertxEventBusService.on('doctors.update', {}, doctorsUpdateHandler);


          vm.$onDestroy = function () {
            vertxEventBusService.unregisterHandler('doctors.update', {}, doctorsUpdateHandler);
          };


        }] // controller
    }); // component
  
  // klammerfriedhof
}());